import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categories: string[];
  rating: number;
  views: string;
  status?: string;
  chapters?: number;
  updatedAt?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  status,
  chapters,
  updatedAt,
  size = 'md',
}: ComicCardProps) {
  const sizeClasses = {
    sm: 'w-[140px]',
    md: 'w-[170px]',
    lg: 'w-[200px]',
  };

  const coverHeights = {
    sm: 'h-[186px]',
    md: 'h-[226px]',
    lg: 'h-[266px]',
  };

  return (
    <Link
      to={`/comic/${id}`}
      className={`${sizeClasses[size]} flex-shrink-0 group cursor-pointer`}
    >
      <div className={`${coverHeights[size]} relative overflow-hidden rounded-lg mb-2`}>
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          title={`${title} - 飞飞漫画网免费漫画`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <div className="flex items-center gap-2">
              <span className="text-xs font-medium text-white bg-primary-500/80 px-2 py-0.5 rounded-full whitespace-nowrap">
                {rating}分
              </span>
              <span className="text-xs text-white/80 whitespace-nowrap">{views}</span>
            </div>
          </div>
        </div>
        {status && (
          <span className={`absolute top-2 right-2 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
            status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-600 text-background-50'
          }`}>
            {status}
          </span>
        )}
      </div>

      <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 truncate">{author}</p>
      {chapters && (
        <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
          共{chapters}话
          {updatedAt && <span className="ml-2">更新于 {updatedAt}</span>}
        </p>
      )}
    </Link>
  );
}